// extracted by mini-css-extract-plugin
export default {"popup-box":"qqFqu8Pniv0zz1RcsncE","popup-spForm-box":"UCo71nGwO4598gd9h70g","popup-close-icon":"sbsFC65KYwReVBJTrE96"};